var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modalMedidas","title":"Medidas Escobilla","ok-only":"","ok-variant":"danger","ok-title":"Cerrar"}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/img/medidas-escobillas.png"),"alt":"Medidas Escobillas","width":"250"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }